import React from 'react';

function BosniaAndHerzegovina(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124193)">
        <mask
          id="mask0_800_124193"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124193)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H33.8824V24H0V0Z"
            fill="#2E42A5"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.5293 0H30.7058V24L9.5293 0Z"
            fill="#FECA00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.46713 2.79376L5.22241 3.4118L5.46013 2.10278L4.45312 1.17573L5.84477 0.984745L6.46713 -0.206238L7.08949 0.984745L8.48113 1.17573L7.47413 2.10278L7.71185 3.4118L6.46713 2.79376Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.159 7.07391L8.9143 7.69195L9.15202 6.38293L8.14502 5.45588L9.53666 5.2649L10.159 4.07391L10.7814 5.2649L12.173 5.45588L11.166 6.38293L11.4037 7.69195L10.159 7.07391Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.62 11.2384L12.3752 11.8564L12.613 10.5474L11.606 9.62037L12.9976 9.42939L13.62 8.2384L14.2423 9.42939L15.634 9.62037L14.627 10.5474L14.8647 11.8564L13.62 11.2384Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.0101 15.2292L15.7654 15.8473L16.0031 14.5383L14.9961 13.6112L16.3877 13.4202L17.0101 12.2292L17.6325 13.4202L19.0241 13.6112L18.0171 14.5383L18.2548 15.8473L17.0101 15.2292Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.662 19.3368L19.4172 19.9548L19.655 18.6458L18.6479 17.7188L20.0396 17.5278L20.662 16.3368L21.2843 17.5278L22.676 17.7188L21.669 18.6458L21.9067 19.9548L20.662 19.3368Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.6991 23.311L23.4543 23.9291L23.6921 22.6201L22.6851 21.693L24.0767 21.502L24.6991 20.311L25.3214 21.502L26.7131 21.693L25.7061 22.6201L25.9438 23.9291L24.6991 23.311Z"
            fill="#F7FCFF"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124193">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default BosniaAndHerzegovina;
